var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-item__field", class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "input-group input-group-booking-detail input-height" },
      [
        _c(
          "label",
          {
            staticClass: "input-label input-group-addon",
            class: _vm.highlight ? "input-highlight" : null,
          },
          [_vm._v(_vm._s(_vm.label))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-control input-height input-container" },
          [
            !_vm.editing
              ? _c("p", { class: _vm.highlight ? "highlight-text" : null }, [
                  _vm.booking.date_options
                    ? _c(
                        "span",
                        _vm._l(
                          _vm.booking.date_options,
                          function (option, index) {
                            return _c("span", { key: index }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("date")(
                                      option,
                                      _vm.$user.date_format_preference
                                    )
                                  ) +
                                  ",\n          "
                              ),
                            ])
                          }
                        ),
                        0
                      )
                    : _vm.booking.date_start && _vm.booking.date_end
                    ? _c("span", [_vm._v(_vm._s(_vm.booking.date_range))])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("date")(
                              _vm.booking.date,
                              _vm.$user.date_format_preference
                            )
                          )
                        ),
                      ]),
                ])
              : _c("div", [
                  _c(
                    "div",
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.dateConfig,
                          placeholder: "DD/MM/YYYY",
                          name: "date",
                        },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.dateConfig,
                          placeholder: "DD/MM/YYYY",
                          name: "date2",
                        },
                        model: {
                          value: _vm.date2,
                          callback: function ($$v) {
                            _vm.date2 = $$v
                          },
                          expression: "date2",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("flat-pickr", {
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.dateConfig,
                          placeholder: "DD/MM/YYYY",
                          name: "date3",
                        },
                        model: {
                          value: _vm.date3,
                          callback: function ($$v) {
                            _vm.date3 = $$v
                          },
                          expression: "date3",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }